import type { Video } from "../types/video";

export const videos: Video[] = [
  // ===== 搞笑 comedy =====
  {
    id: "v01",
    title: "一整个笑不活了！室友的迷惑操作合集",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20playful%20video%20thumbnail%20of%20young%20friends%20laughing%20together%20in%20a%20bright%20cozy%20living%20room%2C%20warm%20orange%20color%20grading%2C%20stylized%20editorial%20photography%2C%20soft%20natural%20light%2C%20clean%20simple%20background%2C%20high%20detail%2C%20energetic%20youthful%20mood%2C%20harmonious%20composition&width=800&height=450&seq=v91-comedy-01&orientation=landscape",
    duration: "03:24",
    plays: 1287000,
    comments: 4821,
    likes: 96300,
    uploadDate: "2026-09-28",
    author: "沙雕研究所",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20smiling%20cartoon%20character%20head%2C%20warm%20orange%20and%20cream%20palette%2C%20simple%20clean%20circular%20background%2C%20friendly%20youthful%20vibe%2C%20high%20detail%2C%20editorial%20illustration%20style&width=200&height=200&seq=v91-avatar-01&orientation=squarish",
    description:
      "和室友同住三年，每天都在怀疑人生。本期合集精选了宿舍里最离谱的十个瞬间，从半夜煮泡面到把洗衣机当成垃圾桶，看完只想说一句：我到底经历了什么。",
    tags: ["宿舍日常", "沙雕", "爆笑", "搞笑合集"],
  },
  {
    id: "v02",
    title: "当代打工人的日常，太真实了吧",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20video%20thumbnail%20of%20a%20tired%20office%20worker%20at%20a%20desk%20with%20coffee%20cups%2C%20warm%20amber%20lighting%2C%20minimal%20clean%20workspace%2C%20editorial%20photography%2C%20soft%20shadows%2C%20high%20detail%2C%20relatable%20everyday%20mood%2C%20orange%20accent%20tones&width=800&height=450&seq=v91-comedy-02&orientation=landscape",
    duration: "02:11",
    plays: 964000,
    comments: 3120,
    likes: 78400,
    uploadDate: "2026-09-25",
    author: "打工魂小林",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20tired%20but%20funny%20office%20worker%20cartoon%20face%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20friendly%20youthful%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-02&orientation=squarish",
    description:
      "闹钟响了八遍还是起不来，通勤路上像沙丁鱼，开会时灵魂出窍。别说你没中招，这就是你我每一天的真实写照。",
    tags: ["打工人", "职场", "共鸣", "日常"],
  },
  {
    id: "v03",
    title: "爸妈的聊天记录有多离谱",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20stylized%20video%20thumbnail%20showing%20a%20smartphone%20chat%20screen%20on%20a%20warm%20cozy%20table%2C%20soft%20orange%20lighting%2C%20clean%20minimal%20composition%2C%20editorial%20flat%20lay%20photography%2C%20high%20detail%2C%20humorous%20family%20mood&width=800&height=450&seq=v91-comedy-03&orientation=landscape",
    duration: "04:02",
    plays: 1520000,
    comments: 6210,
    likes: 121000,
    uploadDate: "2026-09-22",
    author: "家庭段子手",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20friendly%20middle%20aged%20parent%20cartoon%20face%2C%20warm%20orange%20and%20cream%20palette%2C%20simple%20circular%20background%2C%20warm%20humorous%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-03&orientation=squarish",
    description:
      "爸妈用手机绝对是另一个次元。表情包当文字发、语音十分钟只为一句话、把朋友圈当记事本……整理出他们最经典的二十条聊天记录。",
    tags: ["家庭", "父母", "聊天记录", "爆笑"],
  },
  {
    id: "v04",
    title: "沉浸式体验社恐的一天",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20video%20thumbnail%20of%20a%20shy%20person%20hiding%20behind%20a%20notebook%20in%20a%20bright%20cafe%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20soft%20natural%20light%2C%20minimal%20clean%20background%2C%20editorial%20photography%2C%20high%20detail%2C%20introverted%20mood&width=800&height=450&seq=v91-comedy-04&orientation=landscape",
    duration: "01:58",
    plays: 683000,
    comments: 2450,
    likes: 55900,
    uploadDate: "2026-09-19",
    author: "社恐本人",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20shy%20blushing%20cartoon%20face%20peeking%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20soft%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-04&orientation=squarish",
    description:
      "点单要靠朋友、电梯里有人宁愿走楼梯、接电话前先深呼吸三次。如果你也是社恐，这条视频一定懂你。",
    tags: ["社恐", "共鸣", "搞笑", "日常"],
  },
  {
    id: "v05",
    title: "小猫咪的迷惑行为大赏",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Adorable%20stylized%20video%20thumbnail%20of%20a%20playful%20cat%20sitting%20in%20a%20warm%20sunlit%20living%20room%2C%20soft%20orange%20color%20grading%2C%20clean%20minimal%20background%2C%20editorial%20pet%20photography%2C%20high%20detail%2C%20funny%20cute%20mood&width=800&height=450&seq=v91-comedy-05&orientation=landscape",
    duration: "03:37",
    plays: 2103000,
    comments: 8730,
    likes: 168000,
    uploadDate: "2026-09-16",
    author: "猫猫的铲屎官",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20fluffy%20cat%20face%20with%20whiskers%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20playful%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-05&orientation=squarish",
    description:
      "为什么猫总是喜欢把东西推下桌子？为什么半夜跑酷？为什么盯着空气发呆？十几个迷惑瞬间，看完直呼：原来全世界的猫都一个样。",
    tags: ["萌宠", "猫咪", "轻松", "搞笑"],
  },
  {
    id: "v06",
    title: "期末考试前的我 vs 考过之后的我",
    category: "comedy",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20split%20video%20thumbnail%20of%20a%20student%20studying%20late%20versus%20celebrating%2C%20stacks%20of%20books%20and%20notes%2C%20warm%20orange%20desk%20lamp%20lighting%2C%20minimal%20clean%20background%2C%20editorial%20photography%2C%20high%20detail%2C%20comedic%20school%20mood&width=800&height=450&seq=v91-comedy-06&orientation=landscape",
    duration: "02:45",
    plays: 742000,
    comments: 2890,
    likes: 61200,
    uploadDate: "2026-09-13",
    author: "校园观察局",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20cheerful%20student%20cartoon%20face%20with%20glasses%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20youthful%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-06&orientation=squarish",
    description:
      "考前的我：这就是决战时刻。考后的我：全都是缘分。前后反差巨大到像两个人，学生党看了都直呼真实。",
    tags: ["考试", "学生党", "反差", "搞笑"],
  },

  // ===== 娱乐 entertainment =====
  {
    id: "v07",
    title: "舞台高光时刻合辑，燃到起鸡皮疙瘩",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20stylized%20concert%20stage%20video%20thumbnail%20with%20dramatic%20spotlights%20and%20silhouettes%2C%20warm%20amber%20and%20orange%20glow%2C%20clean%20dark%20minimal%20background%2C%20editorial%20entertainment%20photography%2C%20high%20detail%2C%20energetic%20stage%20mood&width=800&height=450&seq=v91-ent-01&orientation=landscape",
    duration: "05:12",
    plays: 1876000,
    comments: 9210,
    likes: 152000,
    uploadDate: "2026-09-29",
    author: "追光娱乐",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20stylish%20performer%20silhouette%20face%20with%20a%20star%2C%20warm%20orange%20and%20gold%20palette%2C%20clean%20circular%20background%2C%20glamorous%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-07&orientation=squarish",
    description:
      "灯光亮起的那一瞬间，全场都在发光。本期精选了年度最炸的十个舞台瞬间，从前奏到高潮，每一秒都值得反复观看。",
    tags: ["舞台", "高光时刻", "合辑", "燃"],
  },
  {
    id: "v08",
    title: "明星采访名场面，笑到停不下来",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20video%20thumbnail%20of%20a%20bright%20talk%20show%20studio%20with%20two%20chairs%20and%20a%20microphone%2C%20warm%20orange%20accent%20lighting%2C%20clean%20minimal%20set%20design%2C%20editorial%20photography%2C%20high%20detail%2C%20lively%20interview%20mood&width=800&height=450&seq=v91-ent-02&orientation=landscape",
    duration: "03:55",
    plays: 1123000,
    comments: 5430,
    likes: 88900,
    uploadDate: "2026-09-26",
    author: "娱乐八倍镜",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20friendly%20host%20face%20with%20a%20microphone%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20cheerful%20entertaining%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-08&orientation=squarish",
    description:
      "被问及理想型时的神回复、突然被 cue 唱歌的尴尬、还有那些笑到破功的瞬间，采访现场简直就是快乐源泉。",
    tags: ["明星", "采访", "名场面", "笑点"],
  },
  {
    id: "v09",
    title: "电影混剪：那些封神的镜头",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20video%20thumbnail%20of%20a%20film%20reel%20and%20clapperboard%20with%20dramatic%20warm%20light%2C%20deep%20orange%20and%20teal%20accents%2C%20clean%20minimal%20background%2C%20editorial%20movie%20photography%2C%20high%20detail%2C%20artistic%20dramatic%20mood&width=800&height=450&seq=v91-ent-03&orientation=landscape",
    duration: "06:30",
    plays: 1456000,
    comments: 6720,
    likes: 118000,
    uploadDate: "2026-09-23",
    author: "光影放映厅",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20film%20director%20cartoon%20face%20with%20a%20beret%2C%20warm%20orange%20and%20amber%20palette%2C%20clean%20circular%20background%2C%20creative%20artistic%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-09&orientation=squarish",
    description:
      "一个镜头，胜过千言万语。精选影史与近年的封神级镜头混剪，配上恰到好处的音乐，看完只想立刻重刷一遍原片。",
    tags: ["电影", "混剪", "镜头美学", "封神"],
  },
  {
    id: "v10",
    title: "娱乐圈年度名场面盘点",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20stylized%20video%20thumbnail%20with%20golden%20confetti%20and%20a%20red%20carpet%2C%20warm%20orange%20and%20gold%20lighting%2C%20clean%20minimal%20background%2C%20editorial%20event%20photography%2C%20high%20detail%2C%20festive%20celebratory%20mood&width=800&height=450&seq=v91-ent-04&orientation=landscape",
    duration: "07:18",
    plays: 986000,
    comments: 4310,
    likes: 76400,
    uploadDate: "2026-09-20",
    author: "年度盘点君",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20cheerful%20reporter%20cartoon%20face%20with%20a%20notepad%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20lively%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-10&orientation=squarish",
    description:
      "这一年娱乐圈到底发生了什么？从惊喜同框到意外发言，按时间线给你完整梳理，一个视频看懂全年热点。",
    tags: ["盘点", "年度", "热点", "娱乐"],
  },
  {
    id: "v11",
    title: "音乐现场 live 直拍合集",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20stylized%20video%20thumbnail%20of%20a%20band%20performing%20on%20stage%20with%20guitars%20and%20warm%20spotlights%2C%20deep%20orange%20glow%2C%20clean%20dark%20minimal%20background%2C%20editorial%20music%20photography%2C%20high%20detail%2C%20emotional%20live%20mood&width=800&height=450&seq=v91-ent-05&orientation=landscape",
    duration: "04:47",
    plays: 823000,
    comments: 3760,
    likes: 69800,
    uploadDate: "2026-09-17",
    author: "现场制噪机",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20musician%20cartoon%20face%20with%20headphones%2C%20warm%20orange%20and%20amber%20palette%2C%20clean%20circular%20background%2C%20chill%20musical%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-11&orientation=squarish",
    description:
      "没有修音、没有后期，只有最真实的现场。本期直拍合集收录了几场让人热泪盈眶的 live 表演，戴上耳机感受一下。",
    tags: ["音乐", "live", "现场", "直拍"],
  },
  {
    id: "v12",
    title: "综艺名场面：全员破防瞬间",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20stylized%20video%20thumbnail%20of%20a%20bright%20variety%20show%20game%20set%20with%20props%20and%20balloons%2C%20warm%20orange%20accent%20colors%2C%20clean%20minimal%20stage%20background%2C%20editorial%20photography%2C%20high%20detail%2C%20playful%20energetic%20mood&width=800&height=450&seq=v91-ent-06&orientation=landscape",
    duration: "05:33",
    plays: 1067000,
    comments: 4980,
    likes: 84100,
    uploadDate: "2026-09-14",
    author: "综艺快乐屋",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20laughing%20variety%20show%20host%20face%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20joyful%20playful%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-12&orientation=squarish",
    description:
      "游戏环节里嘉宾们彻底放飞，笑点密集到需要暂停缓一缓。整理出本季最不容错过的破防名场面，笑到肚子疼。",
    tags: ["综艺", "名场面", "游戏", "欢乐"],
  },

  // ===== 生活 life =====
  {
    id: "v13",
    title: "出租屋改造：1000 元打造 ins 风小家",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20stylized%20video%20thumbnail%20of%20a%20small%20beautifully%20decorated%20rental%20room%20with%20plants%20and%20soft%20textiles%2C%20warm%20afternoon%20sunlight%2C%20cream%20and%20orange%20tones%2C%20minimal%20clean%20interior%2C%20high%20detail%2C%20home%20makeover%20mood&width=800&height=450&seq=v91-life-01&orientation=landscape",
    duration: "08:05",
    plays: 1345000,
    comments: 5890,
    likes: 109000,
    uploadDate: "2026-09-30",
    author: "租房改造日记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20creative%20interior%20designer%20cartoon%20face%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20cozy%20creative%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-13&orientation=squarish",
    description:
      "预算只有一千块，也能让出租屋焕然一新。从墙面到灯光，从收纳到软装，全流程手把手教你花小钱住出幸福感。",
    tags: ["出租屋", "改造", "家居", "省钱"],
  },
  {
    id: "v14",
    title: "打工人早起 vlog，自律的一天",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20stylized%20video%20thumbnail%20of%20a%20morning%20routine%20with%20coffee%2C%20notebook%20and%20sunrise%20light%20through%20a%20window%2C%20warm%20orange%20glow%2C%20clean%20minimal%20background%2C%20editorial%20lifestyle%20photography%2C%20high%20detail%2C%20calm%20productive%20mood&width=800&height=450&seq=v91-life-02&orientation=landscape",
    duration: "06:42",
    plays: 897000,
    comments: 3420,
    likes: 72300,
    uploadDate: "2026-09-27",
    author: "早起的阿May",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20cheerful%20woman%20cartoon%20face%20with%20a%20coffee%20cup%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20fresh%20morning%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-14&orientation=squarish",
    description:
      "六点起床、晨跑、做早餐、列计划，把一天过得井井有条。记录普通打工人如何用早起找回对生活的掌控感。",
    tags: ["vlog", "早起", "自律", "日常"],
  },
  {
    id: "v15",
    title: "独居生活小技巧，租房党必看",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20stylized%20video%20thumbnail%20of%20a%20tidy%20small%20apartment%20kitchen%20with%20organized%20tools%20and%20warm%20lighting%2C%20cream%20and%20orange%20tones%2C%20clean%20minimal%20interior%2C%20editorial%20lifestyle%20photography%2C%20high%20detail%2C%20cozy%20practical%20mood&width=800&height=450&seq=v91-life-03&orientation=landscape",
    duration: "05:26",
    plays: 654000,
    comments: 2710,
    likes: 54800,
    uploadDate: "2026-09-24",
    author: "独居生活家",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20friendly%20young%20person%20cartoon%20face%20at%20home%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20warm%20cozy%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-15&orientation=squarish",
    description:
      "一个人住也要过得舒舒服服。从安全检查、家电使用到深夜暖心小习惯，二十个实用技巧帮你把独居生活经营得明明白白。",
    tags: ["独居", "技巧", "租房", "生活"],
  },
  {
    id: "v16",
    title: "周末 Citywalk 路线推荐",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20stylized%20video%20thumbnail%20of%20a%20sunny%20old%20town%20street%20with%20cafes%20and%20trees%2C%20warm%20orange%20afternoon%20light%2C%20clean%20minimal%20composition%2C%20editorial%20travel%20photography%2C%20high%20detail%2C%20leisurely%20strolling%20mood&width=800&height=450&seq=v91-life-04&orientation=landscape",
    duration: "07:54",
    plays: 712000,
    comments: 3080,
    likes: 59600,
    uploadDate: "2026-09-21",
    author: "城市漫游者",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20traveler%20cartoon%20face%20with%20a%20backpack%20and%20camera%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20adventurous%20friendly%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-16&orientation=squarish",
    description:
      "不用远行，城市里就有很多值得慢慢走的角落。这条路线串起了老街、咖啡馆和日落观景点，全程大概三小时，周末就出发吧。",
    tags: ["Citywalk", "周末", "路线", "城市"],
  },
  {
    id: "v17",
    title: "收纳整理术，小空间也能很清爽",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Organized%20stylized%20video%20thumbnail%20of%20neatly%20arranged%20shelves%20and%20storage%20boxes%20with%20warm%20light%2C%20cream%20and%20orange%20tones%2C%20clean%20minimal%20interior%2C%20editorial%20home%20photography%2C%20high%20detail%2C%20tidy%20satisfying%20mood&width=800&height=450&seq=v91-life-05&orientation=landscape",
    duration: "04:18",
    plays: 528000,
    comments: 2140,
    likes: 44700,
    uploadDate: "2026-09-18",
    author: "整理收纳师",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20calm%20organizer%20cartoon%20face%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20neat%20peaceful%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-17&orientation=squarish",
    description:
      "东西太多、空间太小？其实是你还没找对方法。分享几套亲测有效的收纳逻辑，让你的房间瞬间大出一倍。",
    tags: ["收纳", "整理", "小空间", "生活"],
  },
  {
    id: "v18",
    title: "断舍离 30 天，我的生活变了",
    category: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20stylized%20video%20thumbnail%20of%20a%20minimal%20room%20with%20a%20few%20carefully%20placed%20items%20and%20soft%20daylight%2C%20warm%20cream%20and%20orange%20tones%2C%20clean%20airy%20interior%2C%20editorial%20lifestyle%20photography%2C%20high%20detail%2C%20calm%20minimal%20mood&width=800&height=450&seq=v91-life-06&orientation=landscape",
    duration: "09:12",
    plays: 623000,
    comments: 2890,
    likes: 51200,
    uploadDate: "2026-09-15",
    author: "极简生活记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20peaceful%20person%20cartoon%20face%20with%20a%20plant%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20calm%20serene%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-18&orientation=squarish",
    description:
      "30 天，我扔掉了将近一半的物品。这个过程比想象中更难，也更治愈。记录下每一天的心路历程，或许也能给你一点勇气。",
    tags: ["断舍离", "极简", "挑战", "生活"],
  },

  // ===== 美食 food =====
  {
    id: "v19",
    title: "深夜食堂：一碗治愈系拉面",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Steaming%20stylized%20video%20thumbnail%20of%20a%20delicious%20ramen%20bowl%20with%20soft%20egg%20and%20chashu%2C%20warm%20orange%20lighting%2C%20clean%20minimal%20dark%20table%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20cozy%20comforting%20mood&width=800&height=450&seq=v91-food-01&orientation=landscape",
    duration: "04:36",
    plays: 1562000,
    comments: 6180,
    likes: 128000,
    uploadDate: "2026-09-30",
    author: "深夜食堂主理人",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20friendly%20chef%20cartoon%20face%20with%20a%20bowl%20of%20noodles%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20warm%20appetizing%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-19&orientation=squarish",
    description:
      "加班到深夜，最想的就是一碗热气腾腾的拉面。汤头浓郁、溏心蛋流心、叉烧软嫩，这一碗端上来的时候，整颗心都被治愈了。",
    tags: ["拉面", "深夜", "治愈", "美食"],
  },
  {
    id: "v20",
    title: "在家复刻街边小吃，成本不到 10 元",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20stylized%20video%20thumbnail%20of%20colorful%20street%20food%20snacks%20on%20a%20warm%20wooden%20board%2C%20orange%20and%20amber%20tones%2C%20clean%20minimal%20background%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20tasty%20vibrant%20mood&width=800&height=450&seq=v91-food-02&orientation=landscape",
    duration: "06:08",
    plays: 1089000,
    comments: 4720,
    likes: 91300,
    uploadDate: "2026-09-28",
    author: "小吃复刻机",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20happy%20street%20food%20vendor%20cartoon%20face%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20cheerful%20tasty%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-20&orientation=squarish",
    description:
      "外面卖十几块的小吃，在家几块钱就能搞定。本期复刻了烤冷面、狼牙土豆和手抓饼，步骤简单到新手也能一次成功。",
    tags: ["小吃", "复刻", "省钱", "教程"],
  },
  {
    id: "v21",
    title: "空气炸锅神仙吃法合集",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20stylized%20video%20thumbnail%20of%20golden%20crispy%20air%20fryer%20snacks%20on%20a%20plate%2C%20warm%20orange%20lighting%2C%20clean%20minimal%20kitchen%20counter%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20delicious%20home%20cooking%20mood&width=800&height=450&seq=v91-food-03&orientation=landscape",
    duration: "05:44",
    plays: 1324000,
    comments: 5560,
    likes: 115000,
    uploadDate: "2026-09-25",
    author: "炸锅实验室",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20an%20experimental%20cook%20cartoon%20face%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20curious%20playful%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-21&orientation=squarish",
    description:
      "自从有了空气炸锅，我家的烤箱都吃灰了。整理了十几个零失败的懒人食谱，从下午茶到夜宵，一部视频全搞定。",
    tags: ["空气炸锅", "懒人", "食谱", "合集"],
  },
  {
    id: "v22",
    title: "探店：藏在巷子里的宝藏火锅",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Inviting%20stylized%20video%20thumbnail%20of%20a%20bubbling%20hot%20pot%20with%20fresh%20ingredients%20on%20a%20warm%20table%2C%20orange%20and%20red%20tones%2C%20clean%20minimal%20background%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20festive%20mouthwatering%20mood&width=800&height=450&seq=v91-food-04&orientation=landscape",
    duration: "07:22",
    plays: 968000,
    comments: 4130,
    likes: 79600,
    uploadDate: "2026-09-22",
    author: "本地探店王",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20an%20enthusiastic%20foodie%20cartoon%20face%20with%20chopsticks%2C%20warm%20orange%20and%20beige%20palette%2C%20clean%20circular%20background%2C%20excited%20hungry%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-22&orientation=squarish",
    description:
      "没有显眼的招牌，只有本地人才知道的小巷火锅。麻辣鲜香、食材新鲜、价格良心，这一顿吃得太过瘾，忍不住想分享给你。",
    tags: ["探店", "火锅", "宝藏小店", "美食"],
  },
  {
    id: "v23",
    title: "早餐不重样，一周食谱分享",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20stylized%20video%20thumbnail%20of%20an%20inviting%20breakfast%20spread%20with%20eggs%20toast%20and%20fruit%2C%20warm%20orange%20morning%20light%2C%20clean%20minimal%20table%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20fresh%20healthy%20mood&width=800&height=450&seq=v91-food-05&orientation=landscape",
    duration: "08:30",
    plays: 745000,
    comments: 3260,
    likes: 63700,
    uploadDate: "2026-09-19",
    author: "早餐研究所",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20cheerful%20cook%20cartoon%20face%20with%20an%20egg%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20sunny%20morning%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-23&orientation=squarish",
    description:
      "每天早起十分钟，就能吃到不一样的早餐。七天七个做法，简单快手又好看，让你从此告别路边摊，元气满满开启一天。",
    tags: ["早餐", "食谱", "一周", "健康"],
  },
  {
    id: "v24",
    title: "甜品控必看！零失败提拉米苏",
    category: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20video%20thumbnail%20of%20a%20tiramisu%20dessert%20slice%20with%20cocoa%20dusting%2C%20warm%20orange%20lighting%2C%20clean%20minimal%20plate%2C%20editorial%20dessert%20photography%2C%20high%20detail%2C%20sweet%20indulgent%20mood&width=800&height=450&seq=v91-food-06&orientation=landscape",
    duration: "05:15",
    plays: 1218000,
    comments: 5040,
    likes: 104000,
    uploadDate: "2026-09-16",
    author: "甜度超标",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cute%20minimalist%20flat%20avatar%20illustration%20of%20a%20sweet%20dessert%20baker%20cartoon%20face%2C%20warm%20orange%20and%20cream%20palette%2C%20clean%20circular%20background%2C%20sweet%20cozy%20vibe%2C%20high%20detail%20illustration&width=200&height=200&seq=v91-avatar-24&orientation=squarish",
    description:
      "不用烤箱、不用吉利丁，在家也能做出咖啡馆级别的提拉米苏。层层绵密、入口即化，跟着做绝对不会翻车。",
    tags: ["甜品", "提拉米苏", "烘焙", "教程"],
  },
];